<template>
  <div class="moment-popup">
    <div class="popup-inner" v-if="moment">
      <div class="close-button" @click="closePopup">
        <img :src="closeButtonImage">
      </div>
      <VuePerfectScrollbar class="scroll-area">
        <div
          v-if="moment.media"
          class="moment-thumbnail"
          :style="{ backgroundImage: `url(${moment.media.url})` }"
        >
          <a
            :href="moment.author_link"
            class="moment-profile-pic"
            target="_blank"
            rel="noopener noreferrer"
            :style="{ backgroundImage: `url(${moment.author.picture})` }"
          >{{moment.author.name}}</a>
        </div>
        <div class="popup-content">
          <h1 class="moment-author-name">@{{moment.author.name}}</h1>
          <div class="moment-sharing">
            <a :href="moment.author.link" target="_blank" rel="noopener noreferrer">
              <i :class="`fab fa-${moment.network}`"></i>
            </a>
          </div>
          <div class="moment-content" v-html="moment.content"></div>
        </div>
      </VuePerfectScrollbar>
    </div>
  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import moment from "moment";
import closeButtonImage from "@/assets/img/experiences/close.svg";
export default {
  name: "momentPopup",
  components: {
    VuePerfectScrollbar
  },
  props: {
    moment: {
      type: Object,
      required: true
    }
  },
  data() {
    return { closeButtonImage };
  },
  methods: {
    closePopup() {
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss">
.moment-popup {
  width: 100vw;
  height: calc(100vh - 52px);
  background-color: #fff;
  position: fixed;
  z-index: 1001;
  left: 0;
  top: 52px;
  right: 0;
  bottom: 0;
  overflow: hidden;
  text-align: center;

  .VueCarousel-inner {
    visibility: visible !important;
  }

  .popup-inner {
    position: relative;
    width: 100%;
    height: 100%;
  }

  .close-button {
    position: absolute;
    top: 14px;
    right: 14px;
    z-index: 2;
    width: 40px;
    height: 40px;

    img {
      width: 40px;
      height: 40px;
    }
  }

  .scroll-area {
    width: 100%;
    height: 100%;
  }

  .popup-content {
    padding: 1rem;
  }

  .moment-thumbnail {
    width: 100vw;
    height: 0;
    padding-bottom: 100vw;
    margin-bottom: 2rem;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    position: relative;

    .moment-profile-pic {
      position: absolute;
      bottom: -41px;
      left: 50%;
      transform: translateX(-50%);
      background-position: center;
      background-size: cover;
      background-repeat: no-repeat;
      width: 83px;
      height: 83px;
      border-radius: 50%;
      border: 2px solid #fff;
      display: block;
      text-indent: -99999px;
    }
  }

  .moment-author-name {
    font-size: 1rem;
    margin: 0 auto 1rem;
    font-weight: bold;
  }

  .moment-sharing {
    margin: 1rem auto;
  }

  .moment-content {
    font-size: 0.75rem;

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      font-size: 0.75rem;
      font-weight: bold;
    }
  }
}
</style>
